module.exports = __webpack_public_path__ + "static/img/q.3be76b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/q.png
// module id = A/Ve
// module chunks = 0